import { Component, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AlertController, LoadingController, ModalController, Platform, NavController, ToastController, PopoverController, MenuController } from '@ionic/angular';
import { AuthenticationService } from './core/modules/auth-core/data/service/authentication.service';
import { IdleTimer } from './shared/helpers/idle-timer';
import { ServiceHelper } from './core/helper/services.helper';
import { ErrorLoggingService } from './core/service/error-logging.service';
import { AnalyticsService } from './data/service/analytics.service';
import { Entity } from './core/data/schema/entity';
import { EntityFactory } from './core/data/schema/entity-factory';
import { HttpService } from 'src/app/core/data/service/http.service';
import { DomSanitizer, Title } from '@angular/platform-browser';


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnDestroy {

  isL57 = false;
  helpRoute: string;

  private alert: HTMLIonAlertElement;

  constructor(
    private router: Router,
    private idleTimer: IdleTimer,
    errSvc: ErrorLoggingService,
    httpService: HttpService,
    authSvc: AuthenticationService,
    alertCtrl: AlertController,
    loadCtrl: LoadingController,
    navCtrl: NavController,
    platform: Platform,
    toastCtrl: ToastController,
    popoverCtrl: PopoverController,
    analyticsSvc: AnalyticsService,
    title: Title,
    menuCtrl: MenuController,
    sanitizer: DomSanitizer,
    modalCtrl: ModalController
  ) {

    Entity.factory = new EntityFactory(httpService);

    ServiceHelper.authSvc = authSvc;
    ServiceHelper.popoverCtrl = popoverCtrl;
    ServiceHelper.loadCtrl = loadCtrl;
    ServiceHelper.navCtrl = navCtrl;
    ServiceHelper.platform = platform;
    ServiceHelper.alertCtrl = alertCtrl;
    ServiceHelper.toastCtrl = toastCtrl;
    ServiceHelper.httpSvc = httpService;
    ServiceHelper.title = title;
    ServiceHelper.menuCtrl = menuCtrl;
    ServiceHelper.sanitizer = sanitizer;
    ServiceHelper.modalCtrl = modalCtrl;
    ServiceHelper.appComponent = this;
    ServiceHelper.analyticsSvc = analyticsSvc;

    authSvc.loginStateChanged.subscribe(state => {
      if (state === 1) {
        authSvc.startIdleTimer();
      }
    });

    // auto-login happens in constructor
    // so the login state change event will not fire
    // so we need to check if the login is valid and start the idle timer if it is
    if (authSvc.isLoginValid()) {
      authSvc.startIdleTimer();
    }

    errSvc.init();

    this.router.events.forEach(item => {
      if (item instanceof NavigationEnd) {
        this.updateHelpBubble(item);
      }
    });

    this.isL57 = authSvc.profile?.username?.endsWith('launch57.com');

    // idle timer events
    this.idleTimer.timeoutWarning.subscribe(() => {
      this.displayAlert('Inactivity Warning', 'You will be logged out in 30 seconds due to inactivity.');
    });

    this.idleTimer.timedOut.subscribe(() => {
      this.displayAlert('Inactivity', 'You have been logged out due to inactivity.');
      authSvc.logout(true);
    });
  }

  ngOnDestroy() {
    this.idleTimer.stop();
  }


  setClipboard() {
    navigator.clipboard.writeText(this.helpRoute);
  }

  updateHelpBubble(item: any) {
    const pageKey = this.getUrl(item.url);
    // Log.debug('Page Key:', pageKey);
    this.helpRoute = pageKey;
  }

  getUrl(page: string) {
    let url = page.replace('/admin/', '').replace(/[0-9]/g, '');
    const slashIndex = url.indexOf('/');
    if (slashIndex > 0) {
      url = url.substring(slashIndex);
    }
    return url;
  }

  private async displayAlert(title: string, message: string) {
    // if we already have an alert, dismiss it
    if (this.alert) {
      await this.alert.dismiss();
    }

    // create a new alert
    this.alert = await ServiceHelper.displayAlert(title, message);

    // display the alert
    this.alert.present();
  }

}
